import { Link, useLocation, useSearchParams, useParams, useNavigate } from 'react-router-dom';
import './ChatBox.css'
import React, { useContext, useEffect, useState, useMemo, useRef } from "react";
import { toast } from "react-toastify";
import config from "../../config.json";
import chatServices from "./Services/chatServices";
import contact from './Images/contact.jpg'
import http from "../../Services/httpService";

export default function ChatBox({ idd, onClose, onMessage }) {
    const [message, setMessage] = useState("")
    const [messages, setMessages] = useState([]);



    useEffect(() => {
        console.log('ChatMessage2', onMessage)
        if (onMessage)
            setMessages(prev => {
                const newMessages = [onMessage, ...prev];
                setTimeout(scrollToBottom, 0);
                return newMessages;
            });
    }, [onMessage]);

    const messagesEndRef = useRef(null);
    const scrollToBottom = () => {
        //messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
        if (messagesEndRef.current) {
            const container = messagesEndRef.current.parentElement;
            //container.scrollTop = container.scrollHeight;
            container.scrollTo({
                top: container.scrollHeight,
                behavior: 'smooth'
            });
        }
    };
    //let navigate = useNavigate();
    useEffect(() => {
        const jwt = http.getLocalJwt();
        if (!jwt || jwt == "") {
            //navigate('/login');
            setMessages([{ message: "وارد شوید" }])
            return;
        }
        listMessage()
        console.log('idd',idd)
    }, []);

    const [isLoading, setIsLoadin] = useState(false);
    const listMessage = async () => {
        setIsLoadin(true);
        await chatServices.listMessage(
            {
                from: 0,
                pageSize: 50,
                filters: { GroupOp: "", Groups: [{ groupOp: "and", rules: [] }] },
                where: "",
                order: "",
            }
        )
            .then(({ data }) => {
                setIsLoadin(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return
                }
                setMessages(data.payload.list);
                //scrollToBottom();
                setTimeout(scrollToBottom, 0);
            })
            .catch(err => {
                setIsLoadin(false);
            });
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            sendMessage(e);
        }
    };

    const [isPosted, setIsPosted] = useState(false);
    const sendMessage = async (e) => {
        e.preventDefault();
        setIsPosted(true);
        await chatServices.sendMessage({ message: message })
            .then(({ data }) => {
                setIsPosted(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return
                }
                //setMessages([{ idUserSend: id, message: message }, ...messages])
                setMessages(prev => {
                    const newMessages = [{ idUserSend: idd, message: message }, ...prev];
                    setTimeout(scrollToBottom, 0);
                    return newMessages;
                });
                setMessage("");
                //scrollToBottom();
            })
            .catch(err => {
                setIsPosted(false);
            });
    }


    const headerRef = useRef(null);
    const footerRef = useRef(null);
    const boxRef = useRef(null)
    const [bodyHeight, setBodyHeight] = useState("calc(100vh - 320px)");

    useEffect(() => {
        const updateBodyHeight = () => {
            if (headerRef.current && footerRef.current && boxRef.current) {
                console.log('boxRef.current', boxRef.current.offsetHeight)
                console.log('footerRef.current.offsetHeight', footerRef.current.offsetHeight)
                console.log('headerRef.current.offsetHeight', headerRef.current.offsetHeight)
                const totalHeight =
                    boxRef.current.offsetHeight -
                    (headerRef.current.offsetHeight + footerRef.current.offsetHeight);
                console.log('totalHeight', totalHeight)
                console.log('calc', `calc(100vh - ${totalHeight}px)`)
                setBodyHeight(`${totalHeight}px`);
            }
        };
        updateBodyHeight();
        window.addEventListener("resize", updateBodyHeight);
        return () => window.removeEventListener("resize", updateBodyHeight);
    }, []);

    return (
        <>
            <div id="box-chat" ref={boxRef}>
                <div id="chatBoxContent"  >
                    <div id="boxHeader" className="d-flex flex-fill" ref={headerRef}>
                        <div className="d-flex">
                            <div
                                style={{ width: "93px", marginRight: "-3px" }}
                                className="pull-right avatar2">
                                <span title="خانم 1" data-container="body" rel="tooltip"
                                >
                                    <img src={`${config.apiUrl}/PicUser/8571.jpg`} />
                                </span>
                                <span title="خانم 2" data-container="body" rel="tooltip" >
                                    <img src={`${config.apiUrl}/PicUser/9961.jpg`}
                                    />
                                </span>
                                <span title="خانم 3" data-container="body" rel="tooltip" >
                                    <img src={`${config.apiUrl}/PicUser/11016.jpg`}
                                    />
                                </span>
                            </div>
                            <div className="pull-right box-title">
                                <div className="title-name">کارشناس خدمات پشتیبانی1</div>
                                <div className="title-text">راهنمای شما در استفاده از سامانه</div>
                            </div>
                        </div>
                        <div id="btn-close-chat"
                            onClick={e => { onClose() }}>
                            <div>
                                <svg fill="#ffffff" height="18" viewBox="0 0 24 24" width="18"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path></svg>
                            </div>
                        </div>
                    </div>
                    <div id="boxBody" className='row1' style={{ height: bodyHeight }} >
                        <div className='col pt-2 ps-3'  >
                            {isLoading &&
                                <div className="spinner-border spinner-border-sm" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            }
                            {messages.length > 0 && [...messages].reverse().map((x, i) => (
                                <div className='row mt-2' key={"mess" + i}>
                                    <div className='col-auto d-flex align-items-end'>
                                        <img className="dc-img" src={contact} />
                                    </div>
                                    <div className='col'>
                                        <div className={`row dcText ${idd == x.idUserSend ? "dcTextSend" : "dcTextRecive"}`}>
                                            <div className='col'>
                                                {x.message}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div ref={messagesEndRef} />
                    </div>
                    <div id="boxFooter" className='d-flex' ref={footerRef}>
                        <div className="form-group w-100">
                            <textarea
                                onKeyDown={handleKeyDown}
                                type="text"
                                name="message"
                                value={message}
                                disabled={isPosted}
                                onChange={e => { setMessage(e.target.value) }}
                                placeholder="پیامی بنویسید..."
                                className="form-control border-0"
                                style={{ overflow: "hidden", overflowWrap: "break-word", height: "30px" }}>
                            </textarea>
                            <span className="material-input"></span>
                        </div>
                        <div className="fix-content d-flex">
                            <a
                                data-toggle="collapse"
                                href="#emoji"
                                className="btn btn-simple btn-emoji  d-none">
                                <svg fill="#bababa" height="22" viewBox="0 0 22 22" width="22"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10c5.5,0,10-4.5,10-10S17.5,2,12,2z M12,21c-4.9,0-9-4.1-9-9c0-5,4.1-9,9-9s9,4.3,9,9 C21,16.7,16.8,21,12,21z M15.5,11c0.8,0,1.5-0.7,1.5-1.5S16.3,8,15.5,8S14,8.7,14,9.5S14.7,11,15.5,11z M8.5,11 c0.8,0,1.5-0.7,1.5-1.5S9.3,8,8.5,8S7,8.7,7,9.5S7.7,11,8.5,11z M12,17.5c2.3,0,4.3-1.5,5.1-3.5H6.9C7.7,16,9.7,17.5,12,17.5z"></path>
                                </svg>
                            </a>
                            {message != "" &&
                                <button
                                    onClick={e => sendMessage(e)}
                                    className="btn btn-simple btn-send">
                                    {!isPosted &&
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="23" height="23"
                                            fill="rgb(209,0,6)"><path d="M22,3,1,12l21,9V14L7,12l15-2Z"></path>
                                        </svg>
                                    }
                                    {isPosted &&
                                        <div className="spinner-border spinner-border-sm" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    }
                                </button>
                            }
                            <a
                                data-toggle="collapse"
                                href="#emoji"
                                className="btn btn-simple btn-emoji d-none">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                    viewBox="0 0 24 24" fill="#bababa">
                                    <path d="M12 15c1.66 0 2.99-1.34 2.99-3L15 6c0-1.66-1.34-3-3-3S9 4.34 9 6v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 15 6.7 12H5c0 3.42 2.72 6.23 6 6.72V22h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"></path>
                                    <path d="M0 0h24v24H0z" fill="none"></path>
                                </svg>
                            </a>
                            {message == "" &&
                                <span className="btn btn-simple  ">
                                    <span className="fileinput-new">
                                        <svg fill="#999999" height="23" viewBox="0 0 24 24" width="23"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path d="M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"></path>
                                        </svg>
                                    </span>
                                    <input id="upload-input" type="file" name="uploads" multiple="" className="d-none" />
                                </span>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

}